import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { isBlogReplacementPlaceholder } from 'common/utils/blogReplacementsUtils'
import { isWebsitePageLinkVisible } from 'common/utils/is-website-page-link-visible'
import { WebsitePageLocale } from 'src/shared/types/website-page-interface'

const isVisibleMenuItem = (
  link: string,
  activePageIds: WebsitePageLocale['id'][] | undefined,
) => {
  return (
    !isBlogReplacementPlaceholder(link) &&
    isWebsitePageLinkVisible(link, activePageIds)
  )
}

export const filterVisibleMenuItems = (
  items: MenuItemInterface[],
  activePageIds: WebsitePageLocale['id'][] | undefined,
): MenuItemInterface[] => {
  return items
    .filter(item => isVisibleMenuItem(item.link, activePageIds))
    .map(item => ({
      ...item,
      subMenuItems: item.subMenuItems?.filter(subItem =>
        isVisibleMenuItem(subItem.link, activePageIds),
      ),
    }))
}
